module.exports = __webpack_public_path__ + "img/private-hitting.97580d87.jpg";